import { render, staticRenderFns } from "./frmteendok.vue?vue&type=template&id=3681587a&"
import script from "./frmteendok.vue?vue&type=script&lang=js&"
export * from "./frmteendok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports